import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export const GamesFilterOptions = {
  All: "All",
  Upcoming: "Upcoming",
  Finished: "Finished",
  Round: "Round",
};

export const PlayersFilterOptions = {
  All: "All",
  Available: "Available",
  Joker: "Joker",
  GroupA: "Group A",
  GroupB: "Group B",
};

export const TournamentsFilterOptions = {
  All: "All",
  Upcoming: "Upcoming",
  Past: "Past",
};

const initialState = {
  players: PlayersFilterOptions.All,
  games: GamesFilterOptions.All,
  tournaments: TournamentsFilterOptions.All,
};

export const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    changePlayersFilter(state, action) {
      state.players = action.payload;
    },
    changeGamesFilter(state, action) {
      state.games = action.payload;
    },
    changeTournamentsFilter(state, action) {
      state.tournaments = action.payload;
    },
  },
});

export const selectPlayersFilter = (state: RootState) => state.filters.players;
export const selectGamesFilter = (state: RootState) => state.filters.games;
export const selectTournamentsFilter = (state: RootState) =>
  state.filters.tournaments;

export const {
  changePlayersFilter,
  changeGamesFilter,
  changeTournamentsFilter,
} = filtersSlice.actions;

export default filtersSlice.reducer;
